/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Fail_Delivery_TitleInputs */

const vi_order_fail_delivery_title = /** @type {(inputs: Order_Fail_Delivery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao hàng thất bại`)
};

/**

* @param {Order_Fail_Delivery_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_fail_delivery_title = /** @type {((inputs?: Order_Fail_Delivery_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Fail_Delivery_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_fail_delivery_title(inputs)
});